import { observer } from "mobx-react-lite";

import { SystemAudioBridge } from "@/components/desktop/system-audio/system-audio-bridge";

export const SystemAudioBridgeWrapper = observer(() => {
  return <SystemAudioBridge />;
});
